<template>
    <div class="mod-config">
        <div style="border-radius: 30px">
            <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()" :rules="dataRule">
                <el-row>
                  <el-form-item label="查询分类" prop="type">
                    <el-select v-model="type" clearable placeholder="请选择" @change="getDataList">
                      <el-option v-for="item in options1" :key="item.value" :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                    <el-form-item label="供应商代码" prop="venderCode">
                        <el-input size="mini" v-model="venderCode" style="width: 150px " placeholder="供应商代码" clearable @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-form-item label="供应商名称" prop="venderName">
                        <el-input size="mini" v-model="venderName" style="width: 150px " placeholder="供应商名称" clearable @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-form-item label="只查看本公司相关供应商" prop="currentSubCompany">
                      <el-switch v-model="currentSubCompany" size="mini" clearable @blur="getDataList"></el-switch>
                    </el-form-item>
                  <el-form-item label="到期日期区间" prop="dueDate">
                    <el-date-picker
                        v-model="dueDate"
                        type="daterange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                  </el-form-item>
                    <el-form-item>
                      <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left:20px">查询</el-button>
                      <el-button size="small" @click="exportData()" icon="el-icon-edit" style="margin-left:20px">导出</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <div v-loading="dataListLoading">
        <el-table :data="dataList" size="mini" :row-class-name="rowClassName"
                  :height="style.gridStyle.height" @selection-change="selectionChangeHandle"
                  border :header-cell-style="{background:'#f5f5f5'}">
            <el-table-column header-align="center" label="序号" align="center" width="55">
                <template slot-scope="scope">
                    {{ scope.row.rowid }}
                </template>
            </el-table-column>

            <el-table-column prop="venderCode" header-align="center" align="left" label="供应商代码" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderCode }}
                </template>
            </el-table-column>
            <el-table-column prop="venderName" header-align="center" align="left" label="供应商名称" min-width="200">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleUpdate(scope.row)"> {{ scope.row.venderName }}</el-button>
                </template>
            </el-table-column>

            <el-table-column prop="venderAbbreviation" header-align="center" align="center" label="供应商简称" min-width="60">
              <template slot-scope="scope">
                {{ scope.row.venderAbbreviation }}
              </template>
            </el-table-column>
            <el-table-column prop="venderContacts" header-align="center" align="left" label="联系人" min-width="130">
              <template slot-scope="scope">
                {{ scope.row.venderContacts }}
              </template>
            </el-table-column>
            <el-table-column prop="venderTel" header-align="center" align="right" label="联系电话" min-width="130">
              <template slot-scope="scope">
                {{ scope.row.venderTel }}
              </template>
            </el-table-column>
            <el-table-column prop="blEndDate" header-align="center" align="left" width="160" label="营业执照到期日期">
                <template slot-scope="scope">
                    {{ scope.row.blEndDate }}<span v-if="scope.row.blLongTerm === 1" style="color: #409EFF; font-weight: bold;">&nbsp;长期</span>
                </template>
            </el-table-column>
            <el-table-column prop="scEndDate" header-align="center" align="left" width="250" label="16949/9000体系证书到期日期">
                <template slot-scope="scope">
                    {{ scope.row.scEndDate }}
                </template>
            </el-table-column>

        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        </div>


        <el-dialog class="abow_dialog " width="90%" top=0 :title="this.activeName" :visible.sync="gpsdialog"
                   style="min-height:100px" @close="closegps" :close-on-click-modal="false">
            <div style="min-hight:100px">
                <div style="margin-top:5px">                        
                    <el-tabs class="supplier-info-tabs" v-model="activeName" type="card" @tab-click="handleClick">
                        <el-tab-pane name="企业概况" :key="'first'">
                            <span slot="label"><span style="color: red">*</span> 企业概况</span>
                            <enterprise-profile ref="enterpriseProfile" :superId="this.supplierId"></enterprise-profile>
                        </el-tab-pane>
                        <el-tab-pane name="主要联系人员" :key="'second'">
                            <span slot="label"><span style="color: red">*</span> 主要联系人员</span>
                            <main-contacts ref="mainContacts" :superId="this.supplierId"></main-contacts>
                        </el-tab-pane>
                        <el-tab-pane label="企业资源情况" name="企业资源情况">
                            <span slot="label"><span style="color: red">*</span> 企业资源情况</span>
                            <resource-info ref="resourceInfo" :superId="this.supplierId"></resource-info>
                        </el-tab-pane>
                        <el-tab-pane  label="工厂及地址" name="工厂及地址">
                            <span slot="label"><span style="color: red">*</span> 工厂及地址</span>
                            <factory-info ref="factoryInfo" :superId="this.supplierId"></factory-info>
                        </el-tab-pane>
                        <el-tab-pane  label="企业经营状况" name="企业经营状况">
                            <span slot="label"><span style="color: red">*</span> 企业经营状况</span>
                            <business-info ref="businessInfo" :superId="this.supplierId"></business-info>
                        </el-tab-pane>
                        <el-tab-pane  label="主要产品目录" name="主要产品目录">
                            <span slot="label"><span style="color: red">*</span> 主要产品目录</span>
                            <product-info ref="productInfo" :superId="this.supplierId"></product-info>
                        </el-tab-pane>
                        <el-tab-pane  label="附件上传" name="附件上传">
                            <span slot="label"><span style="color: red">*</span> 附件上传</span>
                            <attachment-upload ref="attachmentUpload" :superId="this.supplierId"></attachment-upload>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </el-dialog>


    </div>
</template>
<script>
    import {selectSupplierBLandSCPage} from '@/controller/supplier'
    import { getProcessDiagramCurrent,listCommentHistory} from '@/controller/workflow'

    import EnterpriseProfile from '@/views/modules/supplier/common/basicInfo/enterpriseProfile'
    import MainContacts from '@/views/modules/supplier/common/basicInfo/mainContacts'
    import ResourceInfo from '@/views/modules/supplier/common/basicInfo/resourceInfo'
    import FactoryInfo from '@/views/modules/supplier/common/basicInfo/factoryInfo'
    import BusinessInfo from '@/views/modules/supplier/common/basicInfo/businessInfo'
    import ProductInfo from '@/views/modules/supplier/common/basicInfo/productInfo'
    import AttachmentUpload from '@/views/modules/supplier/common/basicInfo/attachmentUpload'
    import {exportSupplierBLandSCData} from "../../../../controller/supplier";

    export default {
        name:'licenseIndex',
        data() {
            return {
                dataForm: {
                    id:'',
                    key: ''
                },
                options1:[{
                  value: 'BL_END_DATE',
                  label: '营业执照'
                }, {
                  value: 'SC_END_DATE ',
                  label: '16949/9000体系证书'
                }],
                currentSubCompany:false,
                dueDate:[],
                type: 'BL_END_DATE',
                showViewer: false,
                fileDialogVisible:false,
                diagramUrl: '',
                activeName: '',
                gpsdialog: false,
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                dialogFormVisible: false,
                formLabelWidth: '120px',
                supplierId:'',
                venderName: '',
                something: '',
                style: {
                    leftStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
                        overflow: "auto"
                    },
                    rightStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
                    },
                    gridStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 255) + "px"
                    }
                },

              dataRule: {
                type: [
                  { required: true, message: '请填写查询分类', trigger: 'blur' }
                ],
              },
                venderCode : '',
            }
        },

        components: {
            EnterpriseProfile,
            ResourceInfo,
            MainContacts,
            FactoryInfo,
            BusinessInfo,
            ProductInfo,
            AttachmentUpload
        },

        activated() {

            this.getDataList()
        },

        methods: {

            dateFormat: function (row, column) {
              var date = row[column.property]
              if (!date) {
                  return ''
              }
              return moment(date).format("YYYY-MM-DD HH:mm:ss")
            },

            viewDiagram(id) {
                getProcessDiagramCurrent({id: id}).then(data => {
                    this.diagramUrl = data.body
                    this.showViewer = true
                })
            },

            // 查询按钮
            queryHandle() {
                this.pageIndex = 1
                if(!this.type){
                  this.$message({message: '请填写查询分类',type: 'warning'})
                  return
                }
                this.getDataList()
            },
          exportData() {
            exportSupplierBLandSCData({
              'pageNo': this.pageIndex,
              'pageSize': this.pageSize,
              'venderCode': this.venderCode,
              'venderName' : this.venderName,
              'type': this.type,
              'applyformType' : 14,
              'dueDate':this.dueDate,
              'currentSubCompany':this.currentSubCompany,}
            ).then(data => {
              if (data && data.code === '00') {
                this.readAsBinaryString(data.body)
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    // this.getDataList()
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          },
          readAsBinaryString(data) {
            const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
            let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
            dom.style.display = 'none';
            dom.href = url;
            dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
            document.body.appendChild(dom);
            dom.click();
          },
          str2Blob(str, mime) {
            var arr = str.split(',')
            var bstr = atob(arr[0]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
              type: mime
            });
          },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true
                selectSupplierBLandSCPage({
                    'pageNo': this.pageIndex,
                    'pageSize': this.pageSize,
                    'venderCode': this.venderCode,
                    'venderName' : this.venderName,
                    'type': this.type,
                    'applyformType' : 14,
                     'dueDate':this.dueDate,
                    'currentSubCompany':this.currentSubCompany,
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                        this.starttime = data.starttime
                        this.endtime = data.endtime
                        this.endtime = data.endtime
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    this.dataListLoading = false
                })
            },
            
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            //多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            //单选
            radioChange(row) {
                this.dataListSelections = row;
            },
            
            

            //已完成未完成筛选
            handleCheckAllChange() {
                this.pageIndex = 1
                this.getDataList()
            },
            rowClassName({
                             row,
                             rowIndex
                         }) {
                //把每一行的索引放进row.id
                row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
            },

            //关闭弹框的事件
            closeDialog() {
                this.getDataList()
            },
            filterHandler(value, row, column) {
                const property = column['property'];
                return row[property] === value;
            },
            




            handleClick: function () {
                if (this.activeName === '企业概况') {
                    this.$refs.enterpriseProfile.getDataList(this.superId)
                }
                if (this.activeName === '主要联系人员') {
                    this.$refs.mainContacts.getDataList(this.superId)
                }
                if (this.activeName === '企业资源情况') {
                    this.$refs.resourceInfo.getDataList(this.superId)
                }
                if (this.activeName === '工厂及地址') {
                    this.$refs.factoryInfo.getDataList(this.superId)
                }
                if (this.activeName === '企业经营状况') {
                    this.$refs.businessInfo.getDataList(this.superId)
                }
                if (this.activeName === '体系认证情况') {
                    this.$refs.certificationInfo.getDataList(this.superId)
                }
                if (this.activeName === '主要产品目录') {
                    this.$refs.productInfo.getDataList(this.superId)
                }
                if (this.activeName === '主要设备清单') {
                    this.$refs.equipmentList.getDataList(this.superId)
                }
                if (this.activeName === '附件上传') {
                    this.$refs.attachmentUpload.getDataList(this.superId)
                }
            },

            handleUpdate(row) {
                this.activeName = '企业概况'
                this.gpsdialog = true
                this.supplierId = row.id
                this.superId = row.id
                this.$nextTick(() => {
                    this.$refs.enterpriseProfile.getDataList(row.id)
                })
            },

            closegps() {
                this.getDataList()
            },



            
        }
    }
</script>